import React from 'react'

export const Top = (props) => <svg
	{...props}
	width="100%"
	height="155"
	preserveAspectRatio="none"
	viewBox="0 0 1440 155"
	fill="none"
	xmlns="http://www.w3.org/2000/svg">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M1440 0H0V81.1402C210.659 -4.25177 439.851 -14.5357 652.207 20.7397C700.042 28.6882 771.283 44.3884 852.648 62.3203L852.652 62.3212C1046.87 105.125 1298.79 160.643 1427.82 153.804C1431.93 153.586 1435.99 153.393 1440 153.225V0Z"
		fill="white"/>
</svg>


export const Bottom = (props) => <svg
	{...props}
	width="100%"
	height="102"
	preserveAspectRatio="none"
	viewBox="0 0 1440 102"
	fill="none"
	xmlns="http://www.w3.org/2000/svg">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M1180.26 77.6748C944.384 124.688 748.316 88.5181 553.252 52.533C377.483 20.1071 202.529 -12.1682 0 16.7045V102H1440V0H1428.08C1355.63 32.1761 1271.98 59.3948 1180.26 77.6748Z"
		fill="white"/>
</svg>


